import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { SWRConfig } from 'swr';
import Theme from '@/components/template/Theme';
import Layout from '@/components/layouts';
import { AuthProvider } from '@/auth';
import Views from '@/views';
import appConfig from './configs/app.config';
import './locales';
import EnvGuard from '@/components/EnvGuard';
import { AppVersionProvider } from '@/context/AppVersionContext'
//
//
const App: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  // Dynamic import for mock data
  useEffect(() => {
    if (appConfig.enableMock) {
      import('./mock');
    }
  }, []);

  // Initialize environment
  useEffect(() => {
    const currentEnv = window.location.hostname;
    const storedEnv = localStorage.getItem('env');
    if (!storedEnv) {
      localStorage.setItem('env', currentEnv);
      console.log('Environment initialized:', currentEnv);
    }
  }, []);

  // Auto reload after 30 seconds if app fails to load
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isLoaded) {
        console.log('App reload due to failed load');
        window.location.reload();
      }
    }, 30000); // 30 seconds
    return () => clearTimeout(timer);
  }, [isLoaded]);

  // Mark as loaded after first render
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  // Idle reload effect (optional)
  useEffect(() => {
    let timer: NodeJS.Timeout;
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        // window.location.reload();
      }, 5 * 60 * 1000);
    };
    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearTimeout(timer);
    };
  }, []);

  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        revalidateIfStale: false,
        revalidateOnReconnect: false,
        shouldRetryOnError: false,
        dedupingInterval: 5 * 60 * 1000,
      }}
    >
      <Theme>
        <BrowserRouter basename="/portal">
          <EnvGuard />
          <AuthProvider>
            {/* app version only maintained version data  */}
            <AppVersionProvider>
              <Layout>
                <Views />
              </Layout>
            </AppVersionProvider>
          </AuthProvider>
        </BrowserRouter>
      </Theme>
    </SWRConfig>
  );
};

export default App;
